import loadable from '@loadable/component';

export const CmsFreeCodeBlockLoadable = loadable(
  () => import('./CmsFreeCodeBlock'),
  { resolveComponent: (module) => module.CmsFreeCodeBlock },
);
